module.exports = __webpack_public_path__ + "static/img/bg3.d44c7dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg3.png
// module id = VTmb
// module chunks = 1